var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var defaultOptions = {
    baseUrl: 'https://uis.example.com/',
    fetch: undefined,
};
var pathMap = {
    listAllAppUsers: 'app-users/',
    listAppUsersForApp: 'apps/{{appToken}}/appusers/',
    createAppUser: 'app-users/',
    updateAppUser: 'apps/{{appToken}}/appusers/{{appUserId}}/',
    createUserRegistrationCode: 'codes/',
};
var UISError = function (message) { return "UIS Error: " + message; };
var UISAPIError = function (message, response) { return ({
    message: "UIS API Error: " + message,
    response: response,
}); };
var UISAdminClient = /** @class */ (function () {
    function UISAdminClient(appToken, jwt, options) {
        var _this = this;
        var _a;
        this.appToken = appToken;
        this.jwt = jwt;
        this.listAppUsersForApp = function (page) { return __awaiter(_this, void 0, void 0, function () {
            var url, resp, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = this.getUrl('listAppUsersForApp', page);
                        return [4 /*yield*/, this.fetch(url, {
                                method: 'GET',
                                headers: {
                                    Authorization: "Bearer " + this.jwt,
                                },
                            })];
                    case 1:
                        resp = _a.sent();
                        if (!resp.ok) {
                            throw UISAPIError('Unable to get list of App Users', resp);
                        }
                        return [4 /*yield*/, resp.json()];
                    case 2:
                        data = _a.sent();
                        return [2 /*return*/, data];
                }
            });
        }); };
        this.listAllAppUsers = function (page) { return __awaiter(_this, void 0, void 0, function () {
            var url, resp, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = this.getUrl('listAllAppUsers', page);
                        return [4 /*yield*/, this.fetch(url, {
                                method: 'GET',
                                headers: {
                                    Authorization: "Bearer " + this.jwt,
                                },
                            })];
                    case 1:
                        resp = _a.sent();
                        if (!resp.ok) {
                            throw UISAPIError('Unable to get list of App Users', resp);
                        }
                        return [4 /*yield*/, resp.json()];
                    case 2:
                        data = _a.sent();
                        return [2 /*return*/, data];
                }
            });
        }); };
        // for legacy calls
        this.listAppUsers = this.listAllAppUsers;
        this.createAppUser = function (profile) { return __awaiter(_this, void 0, void 0, function () {
            var url, body, resp, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = this.getUrl('createAppUser');
                        body = new FormData();
                        body.append('app', this.appToken);
                        if (profile) {
                            body.append('profile', JSON.stringify(profile));
                        }
                        return [4 /*yield*/, this.fetch(url, {
                                method: 'POST',
                                headers: {
                                    Authorization: "Bearer " + this.jwt,
                                },
                                body: body,
                            })];
                    case 1:
                        resp = _a.sent();
                        if (!resp.ok) {
                            throw UISAPIError('Unable to create App User', resp);
                        }
                        return [4 /*yield*/, resp.json()];
                    case 2:
                        data = _a.sent();
                        return [2 /*return*/, data];
                }
            });
        }); };
        this.updateAppUser = function (appUserId, profile, disabled) { return __awaiter(_this, void 0, void 0, function () {
            var url, body, resp, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = this.getUrl('updateAppUser').replace('{{appUserId}}', "" + appUserId);
                        body = new FormData();
                        body.append('app', this.appToken);
                        body.append('profile', JSON.stringify(profile));
                        if (disabled !== undefined) {
                            body.append('disabled', "" + disabled);
                        }
                        return [4 /*yield*/, this.fetch(url, {
                                method: 'PATCH',
                                headers: {
                                    Authorization: "Bearer " + this.jwt,
                                },
                                body: body,
                            })];
                    case 1:
                        resp = _a.sent();
                        if (!resp.ok) {
                            throw UISAPIError('Unable to update App User', resp);
                        }
                        return [4 /*yield*/, resp.json()];
                    case 2:
                        data = _a.sent();
                        return [2 /*return*/, data];
                }
            });
        }); };
        this.createUserRegistrationCode = function (appUserURL, code, additionalContext) { return __awaiter(_this, void 0, void 0, function () {
            var url, body, resp, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = this.getUrl('createUserRegistrationCode');
                        body = new FormData();
                        body.append('app_user', appUserURL);
                        body.append('code', code);
                        if (additionalContext !== undefined) {
                            body.append('additional_context', JSON.stringify(additionalContext));
                        }
                        return [4 /*yield*/, this.fetch(url, {
                                method: 'POST',
                                headers: {
                                    Authorization: "Bearer " + this.jwt,
                                },
                                body: body,
                            })];
                    case 1:
                        resp = _a.sent();
                        if (!resp.ok) {
                            throw UISAPIError('Unable to create User Registration Code', resp);
                        }
                        return [4 /*yield*/, resp.json()];
                    case 2:
                        data = _a.sent();
                        return [2 /*return*/, data];
                }
            });
        }); };
        if (!appToken) {
            throw UISError('You must specify appToken');
        }
        if (!jwt) {
            throw UISError('You must specify a JWT');
        }
        if (!options) {
            this.options = defaultOptions;
        }
        else {
            this.options = __assign(__assign({}, defaultOptions), options);
            if (!this.options.baseUrl) {
                this.options.baseUrl = defaultOptions.baseUrl;
            }
        }
        this.fetch = this.options.fetch || window.fetch.bind(window);
        this.options.baseUrl = (_a = this.options.baseUrl) === null || _a === void 0 ? void 0 : _a.replace('{{app_ubiquity_token}}', this.appToken);
    }
    UISAdminClient.prototype.getUrl = function (endpoint, page) {
        var result;
        result = "" + this.options.baseUrl + pathMap[endpoint];
        if (page) {
            result += "?page=" + page;
        }
        result = result.replace('{{appToken}}', this.appToken);
        return result;
    };
    return UISAdminClient;
}());
export default UISAdminClient;
//# sourceMappingURL=adminclient.js.map